<template>
  <div>
    <ul class="nav nav-sm nav-tabs nav-fill mb-3" v-if="!loginOnly">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: mode === 'register'}"
          @click="mode = 'register'"
          href="javascript:void(0)"
        >
          {{ $t('phrase.create_account') }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="javascript:void(0)"
          @click="mode = 'login'"
          :class="{active: mode === 'login'}"
        >
          {{ $t('word.login') }}
        </a>
      </li>
    </ul>

    <div v-if="mode === 'register' && !loginOnly">
      <v-register-form
        @authenticated="(payload) => {$emit('authenticated', payload)}"
        :as-organisation="asOrganisation"
      />
    </div>
    <div v-else-if="mode === 'login'">
      <v-login-form
        @authenticated="(payload) => {$emit('authenticated', payload)}"
      />
    </div>
  </div>
</template>

<script>
import LoginForm from '@/common/components/auth/LoginForm.vue';
import RegisterForm from '@/common/components/auth/RegisterForm.vue';

export default {
  name: 'AuthForm',
  props: {
    asOrganisation: {
      type: Boolean,
      default() {
        return false;
      },
    },
    loginOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    'v-login-form': LoginForm,
    'v-register-form': RegisterForm,
  },
  data() {
    return {
      mode: 'register',
    };
  },
  created() {
    if (this.loginOnly) {
      this.mode = 'login';
    }
  },
};
</script>
